import constant from '../constants/authenticationConstant';

const user = JSON.parse(localStorage.getItem(process.env.REACT_APP_LS_USER));

export const authInitialState = {
    user: {
        data: user,
        error: null,
        isLoading: false
    }
}

export function authenticationReducer(state, action) {

    switch (action.type) {

        case constant.LOGIN_REQUEST:
            return {
                ...state,
                user: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.LOGIN_SUCCESS:
            return {
                ...state,
                user: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.LOGIN_FAIL:
            return {
                ...state,
                user: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.LOG_OUT:
            return {
                ...state,
                user: {
                    ...authInitialState.user,
                    data: null
                }
            };

        default:
            return state;
    }
}

export default authenticationReducer;
